import React from 'react'
import { ALL_SERVICES, MENU, PAGES } from '../constants';
import { PhoneInTalk, AlternateEmail, LocationOn } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png'

export default function FooterLong() {
    return (

        <section className='bg-map bg-cover md:bg-cover bg-no-repeat'>
            <div className='bg-primary-color bg-opacity-70 py-10 px-8 lg:px-28 text-white '>

                <div className='w-full flex flex-col gap-5 items-center mb-10'>
                    <p className='text-center text-2xl md:text-4xl lg:text-5xl'>Let's get started</p>
                    <p className='text-center text-base md:text-lg w-[70%]'>When it comes to Solar Module Mounting Solutions for your projects, you need a trusted partner. Let Particle Solar Power demonstrate what reliable, quality, and on-time solutions look like in the solar industry.</p>

                    <Link to={PAGES.CONTACT} className='bg-secondary-color px-8 py-3 rounded-md text-sm md:text-lg  transition-transform hover:scale-105'>START WITH A FREE ASSESSMENT</Link>

                </div>

                <div className='flex flex-col gap-10 w-full xl:flex-row lg:gap-5'>

                    <div className='flex-grow overflow-hidden flex-wrap gap-10 '>
                        <h3 className='font-bold text-2xl md:text-3xl text-center mb-5'>Company</h3>
                        <div className='flex flex-row justify-center'>
                            <img src={logo} alt="Logo" className='h-20 block md:block lg:block  md:h-30 lg:h-40 mr-10' />
                            <div className='hidden md:block'>
                                <p className='text-sm lg:w-60'>Particle Solar Power (OPC) Pvt Ltd”, are known as the prominent
                                    Solar Module Mounting Solutions provider started its journey in
                                    mounting structure from 2017. We design, manufacture & supply
                                    Hot Dipped Galvanised or Post Galvanised, Pre-Galvanised and
                                    Aluminium PV Module Mounting structure. We are one stop
                                    solution provider for all Solar Module Mounting challenges.</p>
                            </div>
                        </div>
                    </div>

                    <div className='flex-grow flex flex-col items-center  gap-4'>
                        <h3 className='font-bold text-2xl md:text-3xl text-center'>Links</h3>
                        {
                            [{ name: MENU.ABOUT, page: PAGES.ABOUT }, { name: MENU.SERVICES, page: PAGES.SERVICES }, { name: MENU.CONTACTUS, page: PAGES.CONTACT }].map((i, index) => {
                                return (
                                    <a href={i.page} key={index} >
                                        <p className='hover:text-secondary-color'>{i.name}</p>
                                    </a>
                                )
                            })
                        }

                    </div>

                    <div className='flex-grow items-center flex flex-col gap-4'>
                        <h3 className='font-bold text-2xl md:text-3xl text-center'>Address</h3>

                        <div className='gap-4 flex flex-col'>
                            <a href="tel:+919718965965">
                                <div className='flex flex-row hover:text-secondary-color'>
                                    <PhoneInTalk />
                                    <div className='ml-5'>
                                        <p>Call Us</p>
                                        <p>+919718965965</p>
                                    </div>

                                </div>
                            </a>


                            <a href="mailto:particlesolar@gmail.com">
                                <div className='flex flex-row hover:text-secondary-color'>
                                    <AlternateEmail />
                                    <div className='ml-5'>
                                        <p>Email Us</p>
                                        <p>particlesolar@gmail.com</p>
                                    </div>

                                </div>

                            </a>


                            <div className='flex flex-row'>
                                <LocationOn />

                                <p className='ml-5'>Corporate Office: C-6/65, Sector-5, Rohini, New Delhi-110085
                                    <br />
                                    Production Unit: Khasra No 1127, Gali No 16, Rithala, Delhi-110 085 <br />
                                    Branch Office: G-9 Ganpati Tower, Vaishali Nagar, Jaipur, Rajasthan <br />
                                    Contact: +91 011 40191692, +91-141-2350814, 9718965965, 8130473769
                                </p>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </section>
    )
}
